import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { spacing } = theme;

export const circle = css`
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 1px solid var(--brand-purple-base);
  width: ${spacing.xxl}px;
  height: ${spacing.xxl}px;
`;
